// extracted by mini-css-extract-plugin
module.exports = {"form":"PurchaseOrderForm_form__U3jQ4"};